var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box, Button } from '@mui/material';
import * as Preact from 'preact';
import * as MessageWithAction from './M_MessageWithAction';
import { ArrowForward, DeleteOutline } from '@mui/icons-material';
var AddParts = function (p) {
    return (Preact.h(Preact.Fragment, null,
        Preact.h(Box, { display: "flex", flexDirection: "column", gap: "8px" },
            Preact.h(MessageWithAction.Component, { title: p.addPartsText, message: p.addPartsMessage, actionIcon: Preact.h(ArrowForward, null), actionText: p.buttonText, onActionClick: p.onClick }))));
};
var RemoveParts = function (p) {
    return (Preact.h(Box, { padding: "8px" },
        Preact.h(Button, { startIcon: Preact.h(DeleteOutline, null), variant: "text", fullWidth: true, onClick: p.onClick }, p.buttonText)));
};
export var Component = function (p) {
    return p.status === 'add' ? (Preact.h(AddParts, __assign({}, p))) : p.status === 'remove' ? (Preact.h(RemoveParts, __assign({}, p))) : null;
};
Component.displayName = 'AddParts';
